import { SelectItem } from '@/_components/Select/Select.types';

export const CONVERSATION_MESSAGE_LIMIT = 50;

// TODO @chris custom option is missing
export const TIMEFRAMES: Array<SelectItem> = [
  { name: 'All time', value: 'all_time' },
  { name: 'This week', value: 'this_week' },
  { name: 'Last week', value: 'last_week' },
  { name: 'Last month', value: 'last_month' },
  { name: 'Last quarter', value: 'last_quarter' },
  { name: 'Last year', value: 'last_year' },
  //   { name: 'Custom', value: 'custom' },
];

// TODO @chris turn this back with notifications
export const EXPORT_FORMAT_OPTIONS: Array<SelectItem> = [
  { name: 'PDF', value: 'PDF' },
  { name: 'CSV', value: 'CSV' },
];
